import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, combineLatest, isObservable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';
import { DirectoryStructureSelectors } from 'src/app/store/samwin/directory/directory-structure/directory-structure.selectors';
import { DirectoryEntryRemoteDto } from 'src/generated/swagger';

@Pipe({
   name: 'directoryColumnValue',
})
export class DirectoryColumnValuePipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(
      directoryColumn: DirectoryColumn,
      directoryColumnEntry: DirectoryEntryRemoteDto | Observable<DirectoryEntryRemoteDto>
   ): Observable<string | number | boolean | Date> {
      let directoryColumnEntry$: Observable<DirectoryEntryRemoteDto>;
      if (isObservable(directoryColumnEntry)) {
         directoryColumnEntry$ = directoryColumnEntry;
      } else {
         directoryColumnEntry$ = of(directoryColumnEntry);
      }
      return combineLatest([this.store.select(DirectoryStructureSelectors.getColumnInstance), directoryColumnEntry$])
         .pipe(switchMap(([getColumnInstance, directoryentry]) => of(getColumnInstance(directoryentry, directoryColumn))))
         .pipe(
            map((entry) => {
               if (entry.isValueSet) {
                  return entry.value;
               }
               return '';
            })
         );
   }
}
